import FormHandler from "./ahx-wcpl-ajax-form.js";

export default class AddListHandler extends FormHandler {
    constructor(formElement) {
        super(formElement);

        this.listsTable = document.getElementById("product_lists");
    }

    async submitForm(event) {
        try {
            const list = await super.submitForm(event);

            this.listsTable.insertAdjacentHTML("beforeend", list.row);
            this.listsTable.lastElementChild.style.backgroundColor =
                "rgb(255, 228, 175, 0.2)";
        } catch (error) {
            console.log(error);
        } finally {
            this.hideModal();
        }
    }
}
